function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 4.5773,
  y1: 23,
  x2: 4.5773,
  stroke: "#EA5454",
  strokeWidth: 1.76923
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 13.423,
  y1: 23,
  x2: 13.423,
  stroke: "#EA5454",
  strokeWidth: 1.76923
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 22.2697,
  y1: 23,
  x2: 22.2697,
  stroke: "#EA5454",
  strokeWidth: 1.76923
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5767,
  cy: 11.4995,
  r: 2.65385,
  fill: "#EA5454"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5767,
  cy: 11.4995,
  r: 2.65385,
  fill: "#EA5454"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.4234,
  cy: 18.5757,
  r: 2.65385,
  fill: "#EA5454"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.4234,
  cy: 18.5757,
  r: 2.65385,
  fill: "#EA5454"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.2701,
  cy: 6.19096,
  r: 2.65385,
  fill: "#EA5454"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.2701,
  cy: 6.19096,
  r: 2.65385,
  fill: "#EA5454"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.57737,
  cy: 11.4973,
  r: 3.00769,
  stroke: "#EA5454",
  strokeWidth: 2.83077
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.4231,
  cy: 18.5774,
  r: 3.00769,
  stroke: "#EA5454",
  strokeWidth: 2.83077
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.2698,
  cy: 6.19261,
  r: 3.00769,
  stroke: "#EA5454",
  strokeWidth: 2.83077
});

var SvgManageCampaignsIcon = function SvgManageCampaignsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManageCampaignsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manage-campaigns-icon.52dfa075.svg";
export { ForwardRef as ReactComponent };